import React, { useState } from "react";
import { useTheme, fonts } from "@/theme";

export function AuthShell({ children }) {
  const { colors } = useTheme();
  return (
    <div style={{ minHeight: "100vh", background: colors.brand, display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", padding: "48px 24px", maxWidth: 480, width: "100%", margin: "0 auto" }} className="ritzy-fade">
        <div style={{ fontSize: 40, textAlign: "center" }}>🔮</div>
        <h1 style={{ color: colors.onBrand, fontSize: 32, fontFamily: fonts.display, fontWeight: 700, textAlign: "center", margin: "12px 0 4px" }}>
          RitzyRa Rep HQ
        </h1>
        <p style={{ color: colors.onBrand, opacity: 0.85, fontSize: 14, textAlign: "center", fontFamily: fonts.text, margin: 0 }}>
          Home for the Magical Weirdos
        </p>
        <div style={{ background: colors.surface, borderRadius: 24, padding: 24, marginTop: 28 }}>{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, testId, ...props }) {
  const { colors } = useTheme();
  const [focus, setFocus] = useState(false);
  return (
    <label style={{ display: "block", marginBottom: 16 }}>
      <span style={{ display: "block", color: colors.onSurfaceSecondary, fontSize: 12, fontWeight: 700, fontFamily: fonts.text, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>
        {label}
      </span>
      <input
        data-testid={testId}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        style={{
          width: "100%",
          height: 48,
          padding: "0 14px",
          borderRadius: 14,
          border: `1.5px solid ${focus ? colors.brandPrimary : colors.border}`,
          background: colors.surfaceSecondary,
          color: colors.onSurface,
          fontSize: 15,
          fontFamily: fonts.text,
          outline: "none",
        }}
        {...props}
      />
    </label>
  );
}

export function AuthButton({ children, loading, ...props }) {
  const { colors } = useTheme();
  return (
    <button
      className="pressable"
      disabled={loading}
      style={{
        width: "100%",
        height: 50,
        borderRadius: 16,
        border: "none",
        background: colors.brandPrimary,
        color: colors.onBrandPrimary,
        fontSize: 16,
        fontWeight: 700,
        fontFamily: fonts.text,
        cursor: loading ? "default" : "pointer",
        opacity: loading ? 0.7 : 1,
      }}
      {...props}
    >
      {loading ? "Please wait…" : children}
    </button>
  );
}
